import { useSelector, useDispatch } from "react-redux";
import { Toast } from "@/components/ui/toast";
import { useFacilities } from "@/hooks/useFacilities";
import {
    selectSelectedFacilities,
    setSelectedFacilities,
} from "@/features/filters/filtersSlice";

export const LocationFilterToast = () => {
    const dispatch = useDispatch();
    const selectedFacilities = useSelector(selectSelectedFacilities);
    const { facilities } = useFacilities();

    // Only show toast when some (but not all) facilities are selected
    const isFiltering =
        selectedFacilities.length > 0 &&
        selectedFacilities.length < facilities.length;

    const handleViewAll = () => {
        dispatch(setSelectedFacilities([]));
    };

    // Get the names of selected facilities
    const selectedFacilityNames = facilities
        .filter((facility) => selectedFacilities.includes(facility.id))
        .map((facility) => facility.name);

    // Format names with "and" before the last one
    const formatLocationNames = (names: string[]) => {
        if (names.length === 1) return names[0];
        if (names.length === 2) return `${names[0]} and ${names[1]}`;
        return `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
    };

    const message = `Displaying units from our ${formatLocationNames(selectedFacilityNames)} location${selectedFacilityNames.length > 1 ? "s" : ""} only.`;

    return (
        <Toast
            visible={isFiltering}
            message={message}
            action={{
                label: "View All",
                onClick: handleViewAll,
            }}
        />
    );
};
